import { RegexValidators } from '@libs/validations';
export const GEORGIAN_IBAN_LENGTH = 22;
export const EU_IBAN_MAX_LENGTH = 40;
export const EU_IBAN_MIN_LENGTH = 10;
export const START_CHAR_AMOUNT = 6;
export const END_CHAR_AMOUNT = -6;
export const shortenAddress = (address, startCharAmount = START_CHAR_AMOUNT, endCharAmount = END_CHAR_AMOUNT) => {
    // const middlePart = address.slice(START_CHAR_AMOUNT, END_CHAR_AMOUNT);
    // const replaced = Array.from({ length: middlePart.length }, () => '.').join(''); // replace with exact amount of removed chars
    if (!address)
        return '';
    return (address.slice(0, startCharAmount) + '.....' + address.slice(endCharAmount));
};
// IBAN VALIDATION FOR GEORGIA
export const ibanValidateGe = (iban) => {
    const isValid = RegexValidators.IS_IBAN.test(iban);
    const isLongEnough = iban.length === GEORGIAN_IBAN_LENGTH;
    return isValid && isLongEnough;
};
export const ibanValidateEU = (iban) => {
    return (!!iban &&
        iban.length <= EU_IBAN_MAX_LENGTH &&
        iban.length >= EU_IBAN_MIN_LENGTH);
};
//# sourceMappingURL=validateIban.js.map